export default "__VITE_ASSET__TNmCLxgL__"